// extracted by mini-css-extract-plugin
export var blue = "_2s-g";
export var brand = "_2s-c";
export var darkGrey = "_2s-f";
export var disabled = "_2s-6";
export var disabledSubtle = "_2s-7";
export var error = "_2s-8";
export var green = "_2s-h";
export var grey = "_2s-e";
export var icon = "_2s-0";
export var inherit = "_2s-b";
export var lightGrey = "_2s-d";
export var orange = "_2s-j";
export var pink = "_2s-l";
export var primary = "_2s-1";
export var purple = "_2s-m";
export var quaternary = "_2s-4";
export var quinary = "_2s-5";
export var red = "_2s-k";
export var secondary = "_2s-2";
export var success = "_2s-a";
export var tertiary = "_2s-3";
export var warning = "_2s-9";
export var white = "_2s-n";
export var yellow = "_2s-i";